var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCalendarHour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-booking",
    transform: "translate(-40 -200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_35",
    "data-name": "Ret\\xE2ngulo 35",
    transform: "translate(40 200)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2971",
    "data-name": "Caminho 2971",
    d: "M13.909,11.909h1.364v2.564l2.218,1.282-.682,1.182-2.9-1.673V11.909m3.636-4.545H4.818v10H9.064a6.372,6.372,0,0,1,8.482-8.482V7.364M4.818,19.182A1.818,1.818,0,0,1,3,17.364V4.636A1.812,1.812,0,0,1,4.818,2.818h.909V1H7.545V2.818h7.273V1h1.818V2.818h.909a1.818,1.818,0,0,1,1.818,1.818v5.545a6.364,6.364,0,0,1-9,9H4.818m10-8.955a4.409,4.409,0,1,0,4.409,4.409A4.409,4.409,0,0,0,14.818,10.227Z",
    transform: "translate(37.909 199)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarHour);
export default __webpack_public_path__ + "static/media/icon-CalendarHour.3626871223062871fb7de6bb3fd9a345.svg";
export { ForwardRef as ReactComponent };